export default __webpack_public_path__ + "static/media/sign-vertical.92203a28.png";